import { type FieldPath, type FieldValues, useFormContext } from 'react-hook-form';
import type { InputProps } from '../../../../../types/Form';
import type { HookInputBaseProps } from '../../types';
import { FileInputField } from './FileInputField';

export interface HookFileInputProps<T extends FieldValues = FieldValues> extends Omit<InputProps, 'type'>, HookInputBaseProps<T> {
  name: FieldPath<T>;
  onFileRemove?: (fileIndex: number) => void;
}

export const HookFileInput = <T extends FieldValues>({ formMethods, ...props }: HookFileInputProps<T>) => {
  const { control, watch, setValue, trigger } = useFormContext<T>();

  return <FileInputField {...props} control={formMethods?.control || control} watch={watch} setValue={setValue} trigger={trigger} />;
};
